/* eslint-disable @typescript-eslint/no-explicit-any */
import { replace } from 'es-toolkit/compat';
import Payment from 'payment';

// need to investigate newest payment module and credit card number fields, 2.4.6 removes a visa option
// test difference in handsell in dashboard timeline if upgrading to see behavior change
export const creditCardNumberFilter = {
  formatModelValue(modelValue: string) {
    return modelValue ? (Payment.fns as any).formatCardNumber(modelValue) : modelValue;
  },

  parseViewValue(viewValue: any) {
    return viewValue ? replace(viewValue, /\s/g, '') : viewValue;
  },

  formatOnChange: true,
};

export const creditCardExpiryFilter = {
  formatModelValue(modelValue: string) {
    if (!modelValue) {
      return modelValue;
    }
    if (modelValue.length === 2) {
      return `${modelValue} / `;
    }
    if (modelValue.length >= 3) {
      return replace(modelValue, '/', ' / ');
    }
    return modelValue;
  },

  parseViewValue(viewValue: string) {
    if (!viewValue) {
      return viewValue;
    }
    if (/^\d\d \/$/.test(viewValue)) {
      return viewValue.slice(0, 1);
    }
    if (/^\d\/$/.test(viewValue) && !viewValue.startsWith('0')) {
      return '0' + viewValue;
    }

    const onlyNumbers = replace(viewValue, /[^\d]/g, '');
    if (onlyNumbers.length === 2) {
      return onlyNumbers + '/';
    } else if (onlyNumbers.length > 2) {
      return onlyNumbers.slice(0, 2) + '/' + onlyNumbers.slice(2, viewValue.length);
    }
    return onlyNumbers;
  },

  formatOnChange: true,
};
